import { GROQ_MODEL } from "./groq";

/**
 * Summarize a field note using the Groq summarizer endpoint.
 * @param {object} fieldNote - The field note object to summarize.
 * @returns {Promise<string>} - The summarized text.
 */
export async function summarizeFieldNote(fieldNote) {
  const { name, subtype, latitude, longitude, unit_name } = fieldNote;
  const content = `Facility: ${name || ""}\nSubtype: ${subtype || ""}\nLat: ${latitude || ""}\nLon: ${longitude || ""}\nUnit: ${unit_name || ""}`;
  const body = {
    model: GROQ_MODEL,
    messages: [
      { role: "system", content: "Summarize this BLM facility for Field Notes. Be concise (1 short sentence). Output ONLY the summary, nothing else." },
      { role: "user", content }
    ],
    temperature: 0.3,
    max_completion_tokens: 256,
    top_p: 1,
    stream: false
  };
  try {
    const res = await fetch("https://bylolucjhzsbbouoalah.functions.supabase.co/groq-chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      console.error('Groq summarizer API error:', res.status, res.statusText);
      throw new Error('Failed to summarize field note');
    }
    const data = await res.json();
    return data?.choices?.[0]?.message?.content || "No summary returned.";
  } catch (err) {
    console.error('Groq summarizer fetch error:', err);
    return "No summary returned.";
  }
}
